import * as yup from "yup";
import { localToString } from "../../utilities/StringUtil";

export const FormSchema = yup
  .object({
    playerOneProam: yup.boolean(),
    name: yup.string().required("Este campo es requerido"),
    lastname: yup.string().required("Este campo es requerido"),
    email: yup
      .string()
      .email("Ingrese un email valido")
      .required("Este campo es requerido"),
    phoneNumber: yup.string(),
    mobileNumber: yup.string().required("Este campo es requerido"),
    company: yup.string(),
    documentType: yup.number().required("Este campo es requerido"),
    documentNumber: yup.string().when("documentType", {
      is: 1,
      then: yup
        .string()
        .notOneOf(
          [
            yup.ref("guestDocument"),
            null,
          ],
          "Esta cédula se está utilizando en el formulario."
        )
        .length(11, "Cédula  invalida")
        .required("Este campo es requerido"),
      otherwise: yup
        .string()
        .notOneOf(
          [
            yup.ref("guestDocument"),
            null,
          ],
          "Este pasaporte se está utilizando en el formulario."
        )
        .required("Este campo es requerido"),
    }),
    sex: yup.number().required("Este campo es requerido"),
    tshirtSize: yup.number().required("Este campo es requerido"),
    ghin: yup
      .number()
      .test(
        "len",
        "Mínimo 6 números / Máximo 8 números",
        (val) => localToString(val).length <= 8 && localToString(val).length >= 6
      )
      .required("Este campo es requerido"),
    handicap: yup
      .number()
      .required("Este campo es requerido")
      .max(24, "El handicap maximo es 24"),
    diestro: yup.number().required("Este campo es requerido"),
    gloveSize: yup.number().required("Este campo es requerido"),
    guest: yup.string().required("Este campo es requerido"),
    guestName: yup.string().when("guest", {
      is: "1",
      then: yup.string().required("Este campo es requerido"),
      otherwise: yup.string(),
    }),
    guestLastName: yup.string().when("guest", {
      is: "1",
      then: yup.string().required("Este campo es requerido"),
      otherwise: yup.string(),
    }),
    guestDocumentType: yup.number().when("guest", {
      is: "1",
      then: yup.number().required("Este campo es requerido"),
      otherwise: yup.number(),
    }),
    guestDocument: yup.string().when("guest", {
      is: "1",
      then: yup.string().when("guestDocumentType", {
        is: 1,
        then: yup
          .string()
          .notOneOf(
            [
              yup.ref("documentNumber"),
              null,
            ],
            "Esta cédula se está utilizando en el formulario."
          ),
        otherwise: yup
          .string()
          .notOneOf(
            [
              yup.ref("documentNumber"),
              null,
            ],
            "Este pasaporte se está utilizando en el formulario."
          )
          .required("Este campo es requerido"),
      }),
      otherwise: yup.string(),
    }),
    guestEmail: yup.string().when("guest", {
      is: "1",
      then: yup
        .string()
        .email("Ingrese un email valido")
        .required("Este campo es requerido"),
      otherwise: yup.string(),
    }),
  })
  .required();

export type TRegisterBody = yup.InferType<typeof FormSchema>;
